import { CountryCodes } from '@/generated/graphql';

// Countries where AML (Anti-Money Laundering) rules apply
export const AML_COUNTRIES = [
  CountryCodes.At,
  CountryCodes.Be,
  CountryCodes.Bg,
  CountryCodes.Cy,
  CountryCodes.Cz,
  CountryCodes.De,
  CountryCodes.Dk,
  CountryCodes.Ee,
  CountryCodes.Es,
  CountryCodes.Fi,
  CountryCodes.Fr,
  CountryCodes.Gg,
  CountryCodes.Gf,
  CountryCodes.Gi,
  CountryCodes.Gp,
  CountryCodes.Gr,
  CountryCodes.Hr,
  CountryCodes.Hu,
  CountryCodes.Ie,
  CountryCodes.Il,
  CountryCodes.Is,
  CountryCodes.It,
  CountryCodes.Lt,
  CountryCodes.Li,
  CountryCodes.Lu,
  CountryCodes.Lv,
  CountryCodes.Mq,
  CountryCodes.Mt,
  CountryCodes.Ne,
  CountryCodes.Nl,
  CountryCodes.No,
  CountryCodes.Pl,
  CountryCodes.Pt,
  CountryCodes.Re,
  CountryCodes.Ro,
  CountryCodes.Se,
  CountryCodes.Si,
  CountryCodes.Sj,
  CountryCodes.Sk,
  CountryCodes.Sm,
  CountryCodes.Va,
  CountryCodes.Yt,
];

export const APP_NAME = 'CHECKOUTUINODEWEB_ONBOARDING_LITE';

// Countries where BOLT (Block Off Domestic -Local- Transactions) apply
export const BOLT_COUNTRIES = [CountryCodes.Kr, CountryCodes.Tw];

// Waiting for legal to approve these two countries for the new BFX experience
export const DCC_INELIGIBLE_COUNTRIES = [CountryCodes.Hu, CountryCodes.Il];

// Every country PayPal supports has English enabled, so we fallback to that
export const DEFAULT_ENABLED_LANGUAGES = ['en'];

// These countries are part of GROUP-EMEA but have different legal content
export const EMEA_LITE_COUNTRIES = [
  CountryCodes.Bg,
  CountryCodes.Cy,
  CountryCodes.Gf,
  CountryCodes.Gi,
  CountryCodes.Hr,
  CountryCodes.Li,
  CountryCodes.Mq,
  CountryCodes.Re,
  CountryCodes.Sm,
  CountryCodes.Va,
  CountryCodes.Yt,
];

export const FRAUD_NET_FIELD_LIST = [
  // FI fields
  { id: 'cardCvv', min: 3 },
  { id: 'cardExpiry', min: 7 },
  { id: 'cardNumber', min: 8 },

  // Contact information
  { id: 'email', min: 13 },
  { id: 'firstName', min: 5 },
  { id: 'lastName', min: 5 },
  { id: 'phone', min: 10 },

  // Address fields
  { id: 'city', min: 5 },
  { id: 'line1', min: 5 },
  { id: 'line2', min: 2 },
  { id: 'postalCode', min: 5 },
  { id: 'state', min: 2 },

  // Signup fields
  { id: 'dob', min: 8 },
  { id: 'password', min: 8 },
] as const;

export const GEO_REGIONS = ['APAC', 'EMEA', 'LATAM'] as const;

export const KYC_DOB_NATIONALITY = ['DateOfBirth', 'Nationality'] as const;

export const KYC_DOB_NATIONALITY_ID = [
  'DateOfBirth',
  'Nationality',
  'IdentityDocumentType',
  'IdentityDocumentNumber',
] as const;

export const MULTI_PRODUCT_SUPPORTED = [CountryCodes.Us];

export const LOG_PREFIX = /^weasley_/i;

export const X_APP_NAME = 'checkoutuinodeweb_weasley';

export const CHECKOUT_SESSION_TYPES = {
  BILLING_WITH_PURCHASE: 'BILLING_WITH_PURCHASE',
  BILLING_WITHOUT_PURCHASE: 'BILLING_WITHOUT_PURCHASE',
} as const;

export const USER_ACTIONS = {
  commit: 'COMMIT',
  continue: 'CONTINUE',
} as const;

export const REGULATION_E_COUNTRIES = [CountryCodes.Us];

export const STREAMLINE_COUNTRIES_WITH_CHECKBOX_TERMS = [
  CountryCodes.Il,
  CountryCodes.Kr,
  CountryCodes.Br,
];

export const APPLE_PAY_ELIGIBILITY_METRICS = {
  ERROR: 'GUEST_SIGNUP.APPLE_PAY_ELIGIBILITY.ERROR',
  INELIGIBLE: 'GUEST_SIGNUP.APPLE_PAY_INELIGIBLE',
  START: 'GUEST_SIGNUP.APPLE_PAY_ELIGIBILITY.START',
} as const;
